import {
  GET_FEE_TYPES,
  GET_FEE_TYPES_FAIL,
  GET_FEE_TYPES_SUCCESS,
  ADD_NEW_FEE_TYPE,
  ADD_FEE_TYPE_SUCCESS,
  ADD_FEE_TYPE_FAIL,
  UPDATE_FEE_TYPE,
  UPDATE_FEE_TYPE_SUCCESS,
  UPDATE_FEE_TYPE_FAIL,
  DELETE_FEE_TYPE,
  DELETE_FEE_TYPE_SUCCESS,
  DELETE_FEE_TYPE_FAIL,
  
} from "./actionTypes";

export const getFeeTypes = () => ({
  type: GET_FEE_TYPES,
})

export const getFeeTypesSuccess = (feeTypes) => ({
  type: GET_FEE_TYPES_SUCCESS,
  payload: feeTypes,
})

export const getFeeTypesFail = error => ({
  type: GET_FEE_TYPES_FAIL,
  payload: error,
})

export const addNewFeeType = (feeType) => ({
  type: ADD_NEW_FEE_TYPE,
  payload: feeType,
})

export const addFeeTypeSuccess = (feeType) => ({
  type: ADD_FEE_TYPE_SUCCESS,
  payload: feeType,
})

export const addFeeTypeFail = error => ({
  type: ADD_FEE_TYPE_FAIL,
  payload: error,
})

export const updateFeeType = (feeType) => ({
  type: UPDATE_FEE_TYPE,
  payload: feeType,
})

export const updateFeeTypeSuccess = (feeType) => ({
  type: UPDATE_FEE_TYPE_SUCCESS,
  payload: feeType,
})

export const updateFeeTypeFail = error => ({
  type: UPDATE_FEE_TYPE_FAIL,
  payload: error,
})

export const deleteFeeType = (feeType) => ({
  type: DELETE_FEE_TYPE,
  payload: feeType,
})

export const deleteFeeTypeSuccess = (feeType) => ({
  type: DELETE_FEE_TYPE_SUCCESS,
  payload: feeType,
})

export const deleteFeeTypeFail = error => ({
  type: DELETE_FEE_TYPE_FAIL,
  payload: error,
})

export const resetFeeTypeActionSuccess = () => ({
    type: "RESET_LAST_ACTION_SUCCESS"
});


